
import { useScenario } from "../contexts/ScenarioContext"

import CheckBoxIcon from "./icons/CheckBoxIcon"

const CheckBox = (props) => {
  // need props param to exist in order to access props.children

  const { step, clickHandler, inlineChildren = [] } = props

  const { isChecked } = useScenario()

  const getLabel = (item) => !!item.abbrLabel ? item.abbrLabel : item.label


  return (
    <>
      <label
        onClick={() => clickHandler(step.id)}
        style={{
          fontSize: "0.75em",
          marginBottom: "0"
        }}
      >
        <CheckBoxIcon checked={isChecked(step.id)} />
        {getLabel(step)}
        {inlineChildren}
      </label>
      { !!props.children &&
        props.children
      }
    </>
  )

}

export default CheckBox;
